import api from '@utils/api';
import config from '@/config';

const officerGroupService = {
  // Get officer groups list with pagination
  getOfficerGroups: async (params = {}) => {
    return api.get(config.endpoints.officerGroups.list, params);
  },

  // Get officer group by ID
  getOfficerGroupById: async (id) => {
    return api.get(`${config.endpoints.officerGroups.getById}/${id}`);
  },

  // Create new officer group
  createOfficerGroup: async (officerGroupData) => {
    return api.post(config.endpoints.officerGroups.create, officerGroupData);
  },

  // Update officer group
  updateOfficerGroup: async (officerGroupData) => {
    return api.put(`${config.endpoints.officerGroups.update}/${officerGroupData.id}`, officerGroupData);
  },

  // Delete officer group
  deleteOfficerGroup: async (id) => {
    return api.delete(`${config.endpoints.officerGroups.delete}/${id}`);
  },

  // Bulk delete officer groups
  bulkDeleteOfficerGroups: async (ids) => {
    return api.delete(config.endpoints.officerGroups.delete, {
      params: { ids },
      paramsSerializer: {
        indexes: null,
      },
    });
  },
};

export default officerGroupService;

